import React from "react";
import theme from "theme";
import { Theme, Text, Box, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"faq"} />
		<Helmet>
			<title>
				¡Bienvenidos a Fresh & Green!
			</title>
			<meta name={"description"} content={"En Fresh & Green, nos apasiona ofrecer productos frescos, saludables y llenos de sabor."} />
			<meta property={"og:title"} content={"¡Bienvenidos a Fresh & Green!"} />
			<meta property={"og:description"} content={"En Fresh & Green, nos apasiona ofrecer productos frescos, saludables y llenos de sabor."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/6763d329e5d27700189a34a5/images/avocado-graphic-clipart-design-free-png.webp?v=2024-12-19T08:10:02.039Z"} />
			<meta name={"msapplication-TileColor"} content={"#0CAD1C"} />
		</Helmet>
		<Components.Header3 />
		<Section padding="100px 0 100px 0" background="--color-darkL1" quarkly-title="FAQ-7">
			<Text margin="0px 0px 2rem 0px" font="--headline2" color="--light">
				Preguntas Frecuentes
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="50px 50px"
				lg-grid-template-columns="repeat(2, 1fr)"
				md-grid-template-columns="1fr"
				sm-grid-gap="35px 0"
			>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿En qué se basa el concepto de Fresh & Green?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Fresh & Green se dedica a ofrecer productos frescos, saludables y sostenibles, promoviendo una alimentación basada en plantas que favorezca tanto a las personas como al medio ambiente.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Ofrecen opciones personalizadas para clientes?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Sí, contamos con una variedad de productos personalizables, adaptados a las preferencias dietéticas de cada cliente.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Se puede obtener una franquicia de Fresh & Green?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Sí, ofrecemos oportunidades para formar parte de nuestra red de franquicias. Si estás interesado, puedes ponerte en contacto con nosotros para más detalles.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Fresh & Green es una empresa sostenible?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Sí, nos enorgullece ser una empresa comprometida con la sostenibilidad, utilizando ingredientes de origen responsable y empaques biodegradables.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Es Fresh & Green adecuado para personas con restricciones alimenticias?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Sí, ofrecemos opciones para personas con diversas restricciones alimenticias, como alergias o intolerancias. Puedes encontrar opciones sin gluten, sin soja, entre otras.
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Text margin="0px 0px 15px 0px" font="normal 500 25px/1.2 --fontFamily-sans" color="--light">
						¿Fresh & Green acepta pagos con tarjeta?
					</Text>
					<Text margin="0px 0px 0px 0px" font="normal 300 16px/1.5 --fontFamily-sansHelvetica" color="#b2bac1">
						Sí, aceptamos pagos con tarjeta de crédito y débito, además de transferencias electrónicas y efectivo en algunas localidades.
					</Text>
				</Box>
			</Box>
		</Section>
		<Components.Form />
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"614ce40335c5c8001f7746de"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});